import ViewConstructor from './../components/ViewConstructor';
import { getUrlParameter } from './../../_util';

class GalleryResetPassword extends ViewConstructor {
  /**
    Function fired on mount.

    This adds event listeners for form submission and form mode change (create account or login)
  */
  componentDidEnter() {
    let that = this;
    let $ref = $(`#${ this.state.generatedId }`);
    let errRef = $ref.find('.errors');
    let resetToken = getUrlParameter('token');

    if (!resetToken) {
        $ref.find('.gallery-form-reset-password').hide();
        $ref.find('.errors p').text('Something was missing from the address you used to get here. Please return to your email and try tapping the reset-password link again.');
        $ref.find('.errors').slideDown();
    }

    $ref.find('.gallery-form-reset-password').off().on('submit', function(e) {
      if (e) { e.preventDefault(); }
        var setPw = $ref.find('input[name="gallery_password"]');
        var confirmPw = $ref.find('input[name="gallery_password_confirm"]');
        
        if (setPw.val() === confirmPw.val()) {
            that.state.api.resetPassword({
                token: resetToken,
                pw: setPw.val(),
            }, (res) => {
                if (res.success) {
                    setPw.val('');
                    confirmPw.val('');
                    $ref.find('#my-account-login').trigger('click');
                } else {
                    errRef.find('p').text('There was an issue with your request. Please verify you\'ve clicked the correct link.');
                    $ref.find('.errors').slideDown();
                }
            });
        } else {
            errRef.find('p').text('Those passwords don\'t match. Please type your password correctly in both fields.');
            $ref.find('.errors').slideDown();
        }
    }); 
  }

  render() {
    return `
      <div class="login-container">
        <h2>Reset Your Password</h2>
        <div class="errors">
          <p></p>
        </div>
        <form class="gallery-form-reset-password gallery-form">
            <label for="gallery_password">
                <span>Password:</span>
                <input type="password" name="gallery_password" required />
            </label>
            <label for="gallery_password_confirm">
                <span>Confirm Password:</span>
                <input type="password" name="gallery_password_confirm" />
            </label>
            <div class="login-container__button-container">
                <button type="submit" class="gallery-btn-login">Reset Password</button>
            </div>
        </form>
        

        <div class="hide">
          <a href="/gallery/my-account/login?password-reset" id="my-account-login"></a>
        </div>
      <div>
    `;
  }
}

export default GalleryResetPassword;


// WEBPACK FOOTER //
// ./src/scripts/site/account-views/reset-password.js